export default {
  render(h) {
    return (
      <footer class="bg-accent border-t-4 border-gray-700">
        <div class="container mx-auto px-3 lg:px-6 py-10">
          <div class="flex flex-col lg:flex-row">

            <div class="lg:w-2/12">
              <ul class="text-base text-gray-500 mb-10 lg:mb-0">
                <li>
                  <router-link to={{name: 'CoursesPage'}}>
                    {this.$t('courses')}
                  </router-link>
                </li>
                <li>
                  <router-link to={{name: 'AboutPage'}}>
                    {this.$t('about')}
                  </router-link>
                </li>
                <li>
                  <router-link to={{name: 'HelpPage'}}>
                    {this.$t('help_page.h1')}
                  </router-link>
                </li>
                
              </ul>
            </div>
            <div class="lg:w-4/12">
              <ul class="text-base text-gray-500 mb-10 lg:mb-0">
                <li class="text-white text-2xl font-bold">
                  {this.$t('contact_modal.h1')}
                </li>
                <li class="mb-6">
                  <p class="lg:w-9/12">
                    {this.$t('footer.who_office')}
                  </p>
                </li>
                <li class="mb-6">
                  <a href="tel:+4724139402">
                    {this.$t('footer.telephone')}: +45 45 33 7000
                  </a>
                </li>
                <li>
                  {this.$t('footer.fax')}: +45 45 33 7001
                </li>
              </ul>
            </div>
            <div class="flex-col flex justify-around w-full lg:w-7/12 text-white">
            <div class="flex justify-between items-center">
            <img src={'/img/who-logo_euro-en-white.png'} alt="WHO regional office for Europe" class="h-12 lg:h-20"/>
            <img src={'/img/ukrainian-public-health-ctr-logo-white_stacked.png'} alt="WHO regional office for Europe" class="h-12 lg:h-20"/>
            <img src={'/img/EU emblem_NEG.png'} alt="WHO regional office for Europe" class="h-16 lg:h-24"/>
            </div>
            <div class="w-full mt-10">Ця навчальна платформа перекладена на українську мову в рамках спільної ініціативи Бюро ВООЗ в Україні із Центром громадського здоров’я Міністерства охорони здоров’я України, за фінансової підтримки Європейського Союзу. Його зміст є виключно відповідальністю Бюро ВООЗ в Україні і не обов’язково відображає погляди Європейського Союзу. Оригінальна версія цієї платформи була розроблена Африканським регіональним бюро ВООЗ.</div>
            </div>
          </div>
        </div>
      </footer>
    )
  },
};
